import type { ICustomControlRequestAddEditProps } from '../../interfaces/';
import { translateKey } from '../../../../../translate';
import { InputTextArea } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { FormSection } from '../../../../elements/forms/formSection/FormSection';
import { HorizontalFormGroup } from '../../../../elements/forms/HorizontalFormGroup';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { DiagnosisConclusionSelection } from './DiagnosisConclusionSelection';

export function QuestionAddEdit(props: ICustomControlRequestAddEditProps) {
    return (
        <FormSection title={translateKey('request.question')}>
            <DiagnosisConclusionSelection
                conclusie_diagnose={props.request.customControlData.conclusie_diagnose}
                diagnosis={props.request.diagnosis}
                errors={props.errors}
                handleChangeConclusieDiagnose={props.handleChangeCustomControl}
                handleChangeDiagnosisConsideration={async (diagnosis) =>
                    await props.handleChange('diagnosis', diagnosis)
                }
                service={props.service}
                validateConclusieDiagnose={props.validateOneCustomControl}
                validateDiagnosisConsideration={async () => await props.validateOne('diagnosis')}
            />

            <HorizontalFormGroup hasErrors={props.errors.has('customControlData.vraag')}>
                <FormLabel isRequired>{translateKey('request.question')}</FormLabel>
                <InputContainer>
                    <InputTextArea
                        automation="remark"
                        error={props.errors.get('customControlData.vraag')}
                        onChange={async (value) => await props.handleChangeCustomControl({ vraag: value })}
                        onDoValidate={async () => await props.validateOneCustomControl('vraag')}
                        placeholder={translateKey('request.askQuestionToSpecialist')}
                        value={props.request.customControlData.vraag}
                    />
                </InputContainer>
            </HorizontalFormGroup>

            <HorizontalFormGroup hasErrors={props.errors.has('customControlData.toelichting')}>
                <FormLabel>{translateKey('common.remarks')}</FormLabel>
                <InputContainer>
                    <InputTextArea
                        automation="explanation"
                        error={props.errors.get('customControlData.toelichting')}
                        onChange={async (value) => await props.handleChangeCustomControl({ toelichting: value })}
                        onDoValidate={async () => await props.validateOneCustomControl('toelichting')}
                        placeholder={translateKey('common.remarksOrQuestions')}
                        value={props.request.customControlData.toelichting}
                    />
                </InputContainer>
            </HorizontalFormGroup>
        </FormSection>
    );
}
